import type { FC } from 'react';
import type { IconProps } from './types';

const Package: FC<IconProps> = ({ color = 'currentColor', size = 24, strokeWidth = 1.8, ...props }) => {
  const calculatedStrokeWidth = (Number(strokeWidth) * 16) / Number(size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      color={color}
      fill="none"
      stroke={color}
      strokeWidth={calculatedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M2.83807 5.44812L7.78442 8.31061L12.6971 5.46493" />
      <path d="M7.78329 13.3853V8.3045" />
      <path d="M6.62371 2.66961L3.63238 4.32773C2.95457 4.70305 2.39999 5.64414 2.39999 6.41718V9.58217C2.39999 10.3552 2.95457 11.2963 3.63238 11.6716L6.62371 13.3353C7.26231 13.6883 8.30984 13.6883 8.94844 13.3353L11.9398 11.6716C12.6176 11.2963 13.1722 10.3552 13.1722 9.58217V6.41718C13.1722 5.64414 12.6176 4.70305 11.9398 4.32773L8.94844 2.66401C8.30424 2.3111 7.26231 2.3111 6.62371 2.66961Z" />
    </svg>
  );
};

export default Package;
